export const benefitsContent = {
  title: 'Blue Chip Member Perks',
  backgroundcolor: null,
  singleline: '1',
  velocityDesign: '0',
  benfits: [
    {
      title: { __html: 'Receive our best discounts' },
      img: '/assets/images/bluechip-icon-discounts.png',
      details: 'Standard 10% discount available on every rental',
    },
    {
      title: { __html: 'Free </br>Membership' },
      img: '/assets/images/bluechip-icon-membership.png',
      details: 'Join for free - no fees, dues or contracts',
    },
    {
      title: { __html: 'Priority Counter </br>Service' },
      img: '/assets/images/bluechip-icon-priority.png',
      details: 'Priority counter service when needed, location dependent',
    },
    {
      title: { __html: 'Quicker </br>Reservation' },
      img: '/assets/images/bluechip-icon-reservation.png',
      details: 'Enjoy quicker reservation, pick-up and returns',
    },
    {
      title: { __html: 'Free Authorised Additional Driver' },
      img: '/assets/images/bluechip-icon-additional-driver.png',
      details: 'Spouse or domestic partner',
    },
  ],
}
